import apiClient from "./axios.config";

const vendorsReset = {
  resetPassword: async (resetId, otp, password) => {
    try {
      const response = await apiClient.post("/vendor/reset-password", {
        resetId,
        otp,
        pwd: password,
      });
      return response.data;
    } catch (error) {
      throw error.response ? error.response.data : error;
    }
  },
  resendOtp: async (ownerData) => {
    try {
      const { resetId } = ownerData;
      const response = await apiClient.post(
        `/vendor/reset/resend-otp/${resetId}`
      );
      return response.data;
    } catch (error) {
      throw error.response ? error.response.data : error;
    }
  },
};

export default vendorsReset;
